import { render, staticRenderFns } from "./SyntaxHighlighting.vue?vue&type=template&id=4500a024&"
import script from "./SyntaxHighlighting.vue?vue&type=script&lang=js&"
export * from "./SyntaxHighlighting.vue?vue&type=script&lang=js&"
import style0 from "./SyntaxHighlighting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports